import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merges class names conditionally using clsx and resolves Tailwind CSS class conflicts with tailwind-merge.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/**
 * Resolves a valid sucursal UUID from a given candidate or fallback.
 * Prevents invalid foreign keys ('all', 'default', empty string) from being sent to Supabase.
 */
export function getValidBranchId(
  requestedId: string | null | undefined,
  selectedBranchId: string | null | undefined,
  branches: Array<{ id: string; is_deleted?: boolean }>
): string {
  // 1. Check requestedId
  if (requestedId && requestedId !== 'all' && requestedId !== 'default' && requestedId.trim() !== '') {
    const exists = branches.some((s) => s.id === requestedId && !s.is_deleted);
    if (exists) return requestedId;
  }

  // 2. Check selectedBranchId
  if (selectedBranchId && selectedBranchId !== 'all' && selectedBranchId !== 'default' && selectedBranchId.trim() !== '') {
    const exists = branches.some((s) => s.id === selectedBranchId && !s.is_deleted);
    if (exists) return selectedBranchId;
  }

  // 3. Fallback to first non-deleted sucursal
  const firstValid = branches.find((s) => !s.is_deleted && s.id !== 'all' && s.id !== 'default');
  if (firstValid) return firstValid.id;

  // 4. Return empty string if no valid sucursal exists
  return '';
}
